// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:f65473da-b061-404a-9917-0554be4bb475",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_0zVBXIbTs",
    "aws_user_pools_web_client_id": "2eke3ip9qplitpb9jchc2tj0c1",
    "aws_mobile_analytics_app_id": "e41b143e6251461db29c61f9efd6f676",
    "aws_mobile_analytics_app_region": "us-east-1",
    "aws_content_delivery_bucket": "polygio-demo-20190323160216-hostingbucket-local",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "http://polygio-demo-20190323160216-hostingbucket-local.s3-website.us-east-2.amazonaws.com",
    "aws_dynamodb_all_tables_region": "us-east-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "spanish-local",
            "region": "us-east-2"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "termapi",
            "endpoint": "https://y5xglx0l17.execute-api.us-east-2.amazonaws.com/local",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
